import { useSuspenseQuery } from '@tanstack/react-query';
import { medicalNoteReviewByIdQuery } from '@uplift/queries';
import { MedicalNoteType } from '@uplift/api';
import { useTimezone } from '@uplift/contexts';
import { ClaimCorrectionNoteReview } from '../../../components/patient-chart-review-modal/components/ActivityDetailedView/MedicalNotes/ClaimCorrectionNote';
import { CommunicationNoteReview, DischargeNoteReview } from '../../../components';
import { Box } from '@mui/material';
import React from 'react';

export type MedicalNoteReviewProps = {
  medicalNoteId: string;
};

const NoteLayout: React.VFC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <Box sx={{ width: '100%', px: 3, py: 6 }}>
      {children}
    </Box>
  );
};

export const MedicalNoteReview: React.VFC<MedicalNoteReviewProps> = (props) => {
  const timezone = useTimezone();
  const { data: note } = useSuspenseQuery(medicalNoteReviewByIdQuery(props.medicalNoteId));
  const provider = {
    id: '',
    firstName: '',
    lastName: '',
  };

  switch (note.noteType) {
    case MedicalNoteType.communicationNote:
      return (
        <NoteLayout>
          <CommunicationNoteReview
            provider={provider}
            note={note}
          />
        </NoteLayout>
      );
    case MedicalNoteType.therapyDischargeNote:
    case MedicalNoteType.psychiatryDischargeNote:
      return (
        <NoteLayout>
          <DischargeNoteReview provider={provider} note={note} />
        </NoteLayout>
      );
    case MedicalNoteType.claimCorrectionNote:
      return (
        <NoteLayout>
          <ClaimCorrectionNoteReview provider={provider} note={note} timezone={timezone} />
        </NoteLayout>
      );
    default:
      return null;
  }
};
